function processValue(value) {
  if (Number.isInteger(value)) {
    return Math.abs(value);
  } else if (typeof value === "string" && !isNaN(parseInt(value, 10))) {
    return Math.abs(parseFloat(String(value).replace(/,/g, "")));
  } else {
    throw new Error("Invalid integer value");
  }
}

export const makeDataColumnAbsolute = (worksheet, object) => {
  const changes = [];

  for (let i = 1; i <= worksheet.rowCount; i++) {
    const cellContent = worksheet.getCell(`${object.inColChr}${i}`).value;

    // Check if the cell content is a valid integer
    const isValidDate = cellContent && !isNaN(parseInt(cellContent, 10));
    if (isValidDate) {
      const replace = processValue(cellContent);

      // Track changes only if value actually changed
      if (replace !== cellContent) {
        changes.push({
          rowIndex: i,
          originalValue: cellContent,
          convertedValue: replace,
        });
      }

      worksheet.getCell(`${object.inColChr}${i}`).value =
        replace ?? cellContent;
    }
  }

  return changes;
};
